import { render, staticRenderFns } from "./VFormBuilder.vue?vue&type=template&id=bd49c0e4"
import script from "./VFormBuilder.vue?vue&type=script&lang=ts"
export * from "./VFormBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports